import { useState } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import client from "../../Common/Client/Client";
import Table from "../../Common/table/Table";
import { toast } from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const tableTitle = ["seatNo", "lockedAt"];

const SeatLockReport = () => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [reportDetail, setReportDetail] = useState([]);
  const [error, setError] = useState("");

  const seatLockReportGenerate = async () => {
    const dateObj = new Date(selectedDate);
    const day = String(dateObj.getUTCDate()).padStart(2, "0");
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const formatDate = `${day}/${month}/${year}`;
    try {
      const response = await client.get(
        `/report/seat-lock?date=${formatDate}`,
        { withCredentials: true },
      );
      console.log(response);
      if (response.status === 200) {
        setReportDetail(response.data[0].bookings);
        setError("")
      }

      if (response.status === 204) {
        setReportDetail([]);
        setError("There is no data availble for this date");
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(reportDetail);

  const handleDownload = () => {
    if (reportDetail.length === 0) {
      toast.error("No booking data available to download.");
      return;
    }

    // Sort by seat number
    const sortedBookings = reportDetail.sort(
      (a, b) => parseInt(a.number) - parseInt(b.number),
    );

    console.log(sortedBookings);

    // Map data for Excel
    const data = sortedBookings.map((item, index) => ({
      "S.no": index + 1,
      "Seat No": item.seatNo,
      "Date/Time": dateTime(item.createdAt),
    }));

    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Booking Data");

    // Export to file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(fileData, `admin-booking-${selectedDate}.xlsx`);
  };

  function dateTime(date) {
    //console.log(date)
    const isoString = date;
    const dateObj = new Date(isoString);

    // Convert to IST
    const istDateTime = dateObj.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return istDateTime;
  }

  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Admin Seat Lock Report</li>
            </ol>
          </nav>
        </div>
        <section
          className="section dashboard"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "70px",
          }}
        >
          <div className="card" style={{ width: "100%" }}>
            <div className="card-body" style={{ padding: "20px" }}>
              <h5
                className="card-title"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                Admin Seat Lock Report
              </h5>
              <div className="row align-items-center">
                <div className="offset-md-3 col-md-6">
                  <div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Select Travel Date"
                        value={selectedDate}
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          setSelectedDate(newValue);
                        }}
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="offset-md-3 col-md-6 d-flex justify-content-center">
                  <Button
                    variant="contained"
                    onClick={seatLockReportGenerate}
                    // disabled={open}
                    style={{
                      backgroundColor: "#e89e25 ",
                      marginTop: "10px",
                    }}
                  >
                    Generate Report
                  </Button>
                </div>

                {reportDetail.length > 0 && (
                  <div className="col-md-4">
                    <div className="xcel-button">
                      <button
                        onClick={handleDownload}
                        style={{
                          backgroundColor: "green ",
                          color: "white",
                          border: "none",
                          padding: "10px 15px",
                          borderRadius: "10px",
                        }}
                      >
                        DownLoad In Excel
                      </button>
                    </div>
                  </div>
                )}

                {reportDetail.length > 0 && (
                  <div className="col-md-12">
                    <Table
                      tableTitle={tableTitle}
                      report={reportDetail}
                      selectedDate={selectedDate}
                    />
                  </div>
                )}

                {error && (
                  <h5
                    className="card-title"
                    style={{ textAlign: "center", marginBottom: "20px" }}
                  >
                    {error}
                  </h5>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default SeatLockReport;
